import { Send, Settings } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { useExistingConversation } from '@/global/chat/api/getExistingConversation';
import { useSession } from '@/hooks/useSession';
import useConversationStore from '@/stores/Conversation';
import { useSignInDialog } from '@/stores/SignInDialog';
import { User } from '@/types';

interface UserActions {
  userData: User;
}
const UserActions: React.FC<UserActions> = ({ userData }) => {
  const { isLoggedIn, session } = useSession();
  const { setIsOpen, setSelectedConversation } = useConversationStore();
  const { open: openSignInDialog } = useSignInDialog();
  const existingConversationQuery = useExistingConversation({
    targetSteamid: userData.id,
    queryConfig: {
      enabled: isLoggedIn && userData.id !== undefined,
    },
  });

  if (!isLoggedIn) {
    return (
      <Button variant="secondary" onClick={openSignInDialog}>
        <Send className="hidden sm:block" />
        Send DM
      </Button>
    );
  }

  const openChatDialog = () => {
    setSelectedConversation(existingConversationQuery.data);
    setIsOpen(true);
  };

  return (
    <div className="flex items-center gap-x-4">
      {session.user.id === userData.id ? (
        <Link to={`/profilesettings`}>
          <Button variant="secondary" size="icon" title="Settings">
            <Settings name="Settings" />
          </Button>
        </Link>
      ) : (
        <Button variant="secondary" onClick={openChatDialog}>
          <Send className="hidden sm:block" />
          Send DM
        </Button>
      )}
    </div>
  );
};

export { UserActions };
